import { features } from '@/mocks/homepage';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900">平台特色</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">为什么 800 万用户选择爆料专区</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 rounded-xl p-5 md:p-6 text-center group hover:bg-background-50 transition-colors duration-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary-100 rounded-xl mx-auto mb-3 md:mb-4">
                <i className={`${feature.icon} text-primary-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}